<template>
  <div class="base-layout">
    <img class="wave" src="../assets/wave.png" />
    <div class="base-layout__container">
      <div class="image-container">
        <img class="img" src="../assets/img.svg" />
      </div>
      <div class="base-layout__content">
        <img :class="['gazpostach-logo', {'tmgaz-logo': isTmgaz}]" :src="logoImg" />
        <router-view></router-view>
      </div>
    </div>
    <a class="ob-logo" href="https://opendatabot.ua/" target="_blank">
      <img src="../assets/ob_logo.png" alt="Опендатабот" />
    </a>
  </div>
</template>
<script>
import domainMixin from '../mixins/domain';

export default {
  name: 'BaseLayout',
  mixins: [domainMixin],
};
</script>
<style lang="scss">
.wave {
  position: fixed;
  height: 100%;
  left: 0;
  bottom: 0;
  z-index: -1;
}
.base-layout {
  display: flex;
  flex-direction: column;
  &__container {
    // width: 100vw;
    flex: 1;
    display: grid;
    grid-template-columns: 1fr 1.5fr;
    // grid-gap: 7rem;
    .image-container {
      display: flex;
      justify-content: center;
    }
    .img {
      width: 500px;
      align-self: center;
      top: 50%;
      transform: translate(0%, -50%);
      position: fixed;
    }
  }
  &__content {
    width: 100%;
    align-self: center;
    height: auto;
    .gazpostach-logo {
      width: 120px;
      &.tmgaz-logo {
        width: 190px;
      }
    }
  }
}

.create-application-btn {
  width: 100%;
  background-color: #ff7f00;
  border-color: #ff7f00;
  text-transform: uppercase;
  height: 50px;
  border-radius: 30px !important;
  &:active {
    background-color: darken(#ff7f00, 3%);
    border-color: darken(#ff7f00, 3%);
  }
  &:hover {
    background-color: darken(#ff7f00, 3%);
    border-color: darken(#ff7f00, 3%);
  }
}

.login-link {
  color: #ff7f00;
}

@media screen and (max-width: 1080px) {
  .wave {
    width: 55%;
  }
  .image-container {
    img {
      width: 420px;
    }
  }
}

@media screen and (max-width: 840px) {
  .gazpostach-logo {
    width: 90px !important;
    &.tmgaz-logo {
      width: 150px !important;
    }
  }
  .wave {
    width: 55%;
  }
  .image-container {
    img {
      width: 357px;
    }
  }
  .base-layout__content {
    width: 70%;
  }
}

@media screen and (max-width: 740px) {
  .gazposatch-logo,
  .gazpostach-logo {
    width: 80px !important;
    &.tmgaz-logo {
      width: 130px !important;
    }
  }
  .wave {
    width: 57%;
  }
  .image-container {
    img {
      width: 310px;
    }
  }
  .base-layout__content {
    width: 70%;
  }
}

@media screen and (max-width: 640px) {
  .gazpostach-logo {
    width: 80px !important;
    &.tmgaz-logo {
      width: 130px !important;
    }
  }
  .wave {
    width: 57%;
  }
  .image-container {
    img {
      width: 270px;
    }
  }
  .base-layout__content {
    width: 80%;
  }
}

@media screen and (max-width: 580px) {
  .gazpostach-logo {
    width: 60px !important;
    &.tmgaz-logo {
      width: 110px !important;
    }
  }
  .wave {
    width: 53%;
  }
  .image-container {
    img {
      width: 225px;
    }
  }
  .base-layout__content {
    width: 85%;
  }
}

@media screen and (max-width: 579px) {
  .gazpostach-logo {
    width: 60px !important;
    &.tmgaz-logo {
      width: 110px !important;
    }
  }
  .wave {
    display: none;
  }
  .base-layout__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .image-container {
    img {
      display: none;
    }
  }
  .base-layout__content {
    width: 85%;
  }
}
</style>